<template>
  <div class="page_body">
     <img class="big_img" src="../../assets/img/login_course_top.png" />
      <p class="course_p">{{$t('m.scan_login_desc')}}</p>
      <div class="course_step">
        <!-- <img class="big_img" src="../../assets/img/llogin_bj02.png.png" /> -->
        <img class="course_step_title" src="../../assets/img/img01.png" />
        <div class="course_step_con">
          <p class="course_p">{{$t('m.scan_login_a_title')}}</p>
          <p class="course_p">{{$t('m.scan_login_a_p1')}}</p>
          <div class="fc-text-center">
            <img class="course_img" src="../../assets/img/login_part01_img01.png" />
          </div>
          <p class="course_p">{{$t('m.scan_login_a_p2')}}</p>
          <div class="fc-text-center">
            <img class="course_img" src="../../assets/img/login_part01_img02.png" />
          </div>
          <p class="course_p">{{$t('m.scan_login_a_p3')}}</p>
          <div class="fc-text-center">
            <img class="course_img" src="../../assets/img/login_part01_img03.png" />
          </div>
        </div>
        <img class="course_step_title" src="../../assets/img/img04.png" />
      </div>
      <div class="course_step">
        <img class="course_step_title" src="../../assets/img/img02.png" />
        <div class="course_step_con">
          <p class="course_p">{{$t('m.scan_login_b_title')}}</p>
          <p class="course_p">{{$t('m.scan_login_b_p1')}}</p>
          <div class="fc-text-center">
            <img class="course_img" src="../../assets/img/login_part02_img01.png" />
          </div>
          <p class="course_p">{{$t('m.scan_login_b_p2')}}</p>
          <div class="fc-text-center">
            <img class="course_img" src="../../assets/img/login_part01_img02.png" />
          </div>
          <p class="course_p">{{$t('m.scan_login_b_p3')}}</p>
          <div class="fc-text-center">
            <img class="course_img" src="../../assets/img/login_part02_img03.png" />
          </div>
        </div>
        <img class="course_step_title" src="../../assets/img/img04.png" />
      </div>
      <p class="course_p course_p2">{{$t('m.scan_login_lesson_end')}}</p>
      <div class="fc-text-center fc-pad-tb-biger">
        <img class="course_footer_logo" src="../../assets/img/login_bj_logo.png" />
      </div>
  </div>
</template>
<script>
  import Vue from 'vue';
  import {
    Toast
  } from 'vant';
  Vue.use(Toast);

  export default {
    name: 'Course',
    components: {

    },
    data() {
      return {
        loginType:0,//登录类型 0 三方登录 1扫码登录
      }
    },
    filters: {

    },
    watch: {

    },
    mounted() {
      this.getLang();
      localStorage.setItem('localTab','scan');
    },
    methods: {
      getLang() {
        var box = document.getElementById("app");
        let language = navigator.language || navigator.browserLanguage;
        if (language == 'ar') {
          box.style.direction = 'rtl';
        } else {
          box.style.direction = 'ltr';
        }
      },
    },

  }
</script>


<style scoped>
.page_body{
  background-color: #7A32FF;
  color: #fff;
  padding-bottom: .6rem;
}
.big_img{
  width: 100%;
}
.course_img{
  width: 6.76rem;
  margin: .3rem auto .78rem;
}
.course_p{
  padding: .5rem .3rem;
  font-size: .28rem;
  line-height: 2;
}
.course_p2{
  padding-top: 0;
  padding-bottom: 0;
  margin-top: -.2rem;
}
.course_step{
  padding-top: 1rem;
  margin-top: -1.3rem;
  margin-bottom: .7rem;
  background: url('../../assets/img/login_bj02.png') no-repeat;
  background-size: 100% auto;
  background-position: top;
}
.course_step_title{
  width: 100%;
}
.course_step_con{
  background: url('../../assets/img/img03.png') repeat-y;
  background-size: 100% auto;
}
.course_step_con .course_p{
  padding:0 .6rem;
  font-size: .26rem;
}
.course_footer_logo{
  width: 1.47rem;
  height: auto;
  margin: auto;
}
</style>



// WEBPACK FOOTER //
// src/pages/Login/LoginCourse.vue